var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.71 44.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    x1: 7873.46,
    y1: -12179.3,
    x2: 8690.27,
    y2: -11185.2,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -265.44, -383.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a735b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    x1: 8028.33,
    y1: -11990.47,
    x2: 8535.03,
    y2: -11373.65,
    xlinkHref: "#Gradiente_sem_nome"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: 8180.28,
    y1: -11803.72,
    x2: 8382.29,
    y2: -11558.68,
    xlinkHref: "#Gradiente_sem_nome"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-insta_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1559916731488",
    "data-name": 1559916731488
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.34.24A12.13,12.13,0,0,0,.07,12.2c0,3.24-.18,20,.14,22.05A12.16,12.16,0,0,0,12.05,44.64c3.25.06,20.25.19,22.31-.15A12.06,12.06,0,0,0,44.63,32.63c.07-3.08.16-20-.1-22A12.16,12.16,0,0,0,32.72.08C29.58,0,12.52-.08,10.34.24Z",
    transform: "translate(0 0)",
    fillRule: "evenodd",
    fill: "url(#Gradiente_sem_nome)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.45,5.82A9.72,9.72,0,0,0,5.86,14a152,152,0,0,0,0,16.54A9.89,9.89,0,0,0,14,38.84a142.24,142.24,0,0,0,16.52,0,9.82,9.82,0,0,0,8.32-8.23,147.44,147.44,0,0,0,0-16.42,9.85,9.85,0,0,0-8.22-8.36,141.55,141.55,0,0,0-16.22,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78,8.7c-3.91.56-6.11,3.25-6.15,7.59,0,3.62-.37,10.54.09,13.81.53,3.69,3.47,6,7.65,6,3.73,0,10.4.38,13.81-.09,3.77-.52,5.9-3.43,5.89-7.66,0-3.73.39-10.37-.07-13.74-.5-3.66-3.46-5.94-7.59-5.94-3.55,0-10.53-.4-13.63,0Z",
    transform: "translate(0 0)",
    fillRule: "evenodd",
    fill: "url(#Gradiente_sem_nome_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31,14.22a8.41,8.41,0,0,0,4,16.35,8.41,8.41,0,1,0-4-16.35Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.65,16.9c-7.28,1.12-5.8,11.82,1.48,10.94a5.59,5.59,0,0,0,4.69-6.33A5.46,5.46,0,0,0,21.65,16.9Z",
    transform: "translate(0 0)",
    fillRule: "evenodd",
    fill: "url(#Gradiente_sem_nome_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,11.72a1.7,1.7,0,0,0-.94,2.5,1.89,1.89,0,0,0,2.51,1A1.91,1.91,0,1,0,30.5,11.72Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.3320bd8e31537aa7eee578819f77eede.svg";
export { ForwardRef as ReactComponent };